// extracted by mini-css-extract-plugin
export default {"header":"about_header__vwS3z","cardsContainer":"about_cardsContainer__pSXcP"};